import script from "./SecurityRibbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SecurityRibbon.vue?vue&type=script&lang=ts&setup=true"

import "./SecurityRibbon.vue?vue&type=style&index=0&id=079e2834&lang=scss"

const __exports__ = script;

export default __exports__